// extracted by mini-css-extract-plugin
export default {"areYouSure":"_9WhgCyOMMAh9aFYbIbo1HQ==","testnetSkip":"VfNH7ee19TtjosFON47nMg=="};